import {LiveCasinoAction, LiveCasinoActionTypes} from "./LiveCasinoActions";
import {LiveCasinoLobby} from "../http/protocol";
import {UserAction, UserActionTypes} from "../user/UserActions";

export enum ListMode {
    THUMBNAIL, DESCRIPTION
}

export enum LiveCasinoStatus {
    LOADING, DONE, ERROR
}
export interface LiveCasinoState {
   lobby?: LiveCasinoLobby;
   selectedCategory?: number;
   selectedCategoryName?: string;
   status?: LiveCasinoStatus;
   mode?: ListMode;
   searchValue?: string;
   recentlyPlayedGames? : string[];
   favouriteGames? : string[];
   selectedStudio? : string;
}

const initialState : LiveCasinoState = { status: LiveCasinoStatus.LOADING, mode: ListMode.THUMBNAIL, searchValue : "", recentlyPlayedGames : [], favouriteGames : [], selectedCategoryName:""};
function sortLobby(lobby : LiveCasinoLobby) {

    if(lobby.categories) {
        lobby.categories.sort((a,b)=>{
            let oa = typeof(a.LobbyOrder) != "undefined" ? a.LobbyOrder : 0;
            let ob = typeof(b.LobbyOrder) != "undefined" ? b.LobbyOrder : 0;
            
            if(oa >ob) return 1;
            if(ob > oa) return -1;
            return 0;
        });
    }
    // if(lobby.games) {
    //   lobby.games.reduce(function (r, a) {
    //       if(a.SubProductCode){
    //     r[a.SubProductCode] = r[a.SubProductCode] || [];
    //     r[a.SubProductCode].push(a);
    //           }
    //     return r;
    // }, Object.create(null));
    // }
    if(lobby.studios) {
        lobby.studios.sort((a,b)=>{
            let oa = typeof(a.Name) != "undefined" ? a.Name: "";
            let ob = typeof(b.Name) != "undefined" ? b.Name: "";
            return oa.localeCompare(ob);
        });
    }
}
export function livecasinoReducer(state: LiveCasinoState = initialState, action : LiveCasinoAction|UserAction ) {

    switch (action.type) {
        case UserActionTypes.LOGIN_RESPONSE:
            return {...state, selectedStudio: undefined};
        case LiveCasinoActionTypes.SELECT_STUDIO:
            let studioName = action.studioName;
            if(state.selectedStudio == studioName) {
                studioName = "0";
            }
            return {...state, selectedStudio : studioName  };
        case LiveCasinoActionTypes.SET_FAVOURITE_GAMES:
            return {...state, favouriteGames : action.GameIds};
        case LiveCasinoActionTypes.SET_PLAYED_GAMES:
            return {...state, recentlyPlayedGames : action.GameIds };
        case LiveCasinoActionTypes.GAMES_RESPONSE:
            sortLobby(action.lobby);
            return {...state, lobby : action.lobby, status: LiveCasinoStatus.DONE, selectedCategory : action.lobby.categories ? action.lobby.categories[0].Id : 0, selectedCategoryName:action.lobby.categories ? action.lobby.categories[0].Name : "All Games"};
        case LiveCasinoActionTypes.GAMES_REQUEST:
            return {...state, status : LiveCasinoStatus.LOADING};
        case LiveCasinoActionTypes.GAMES_ERROR:
            return {...state, status : LiveCasinoStatus.ERROR };
        case LiveCasinoActionTypes.SELECT_CATEGORY:
            return {...state, selectedCategory : action.category, searchValue : "" };
            case LiveCasinoActionTypes.SELECT_CATEGORY_NAME:
        return {...state, selectedCategoryName:action.categoryName };
        case LiveCasinoActionTypes.SELECT_LIST_MODE:
            return {...state, mode : action.mode};
        case LiveCasinoActionTypes.UPDATE_SEARCH_VALUE:
            return {...state, searchValue : action.value};
        default:
            return state;
    }
}
